import { computed } from 'vue';

// Instant Credit (PAYCOMET metodo_pago=24) is ONLY offered in abonado alta / renovación
// flows. Other checkout flows (evento, packs, bases,
// productos, día-abonado, SGA seat change, simpatizantes, etc.) must not surface it
// even if teatro.instant_credit_activo is true. `abonos-sin-recinto` is intentionally
// excluded — see WU-1 design D3 / OQ scope.
const IC_ALLOWED_TIPO_VENTA = new Set([
    'abono',            // alta nueva de abonado (ProcesoCompraAbonadoNormal)
    'abono-alta-lfp',   // alta nueva de abonado variante LFP
    'renovar-abono-lfp' // renovación de abonado (RenovarAbonoLfp)
]);

export function useAvailablePaymentMethods(deps = {}) {
    const methods = computed(() => {
        const teatro = deps.store?.getters?.getTeatro || {};
        const esPlazos = Boolean(deps.esPlazos);
        const tipoVenta = deps.tipoVenta || null;
        const importeCarrito = Number(deps.importeCarrito || 0);
        const minimo = Number(teatro.instant_credit_importe_minimo || 0);

        return [
            {
                id: 'tarjeta',
                titleKey: 'pago.method_card_title',
                descKey: 'pago.method_card_desc',
                iconComponent: 'card',
                available: true
            },
            {
                id: 'bizum',
                titleKey: 'pago.method_bizum_title',
                descKey: 'pago.method_bizum_desc',
                iconComponent: 'bizum',
                available: !esPlazos
            },
            {
                id: 'instant_credit',
                titleKey: 'pago.method_ic_title',
                descKey: 'pago.method_ic_desc',
                iconComponent: 'instant_credit',
                available: !esPlazos
                    && IC_ALLOWED_TIPO_VENTA.has(tipoVenta)
                    && Boolean(teatro.instant_credit_activo)
                    && importeCarrito >= minimo
            }
        ].filter(method => method.available);
    });

    const count = computed(() => methods.value.length);
    const defaultMethod = computed(() => methods.value[0]?.id || null);
    const byId = computed(() => methods.value.reduce((result, method) => ({ ...result, [method.id]: method }), {}));
    const getMethod = id => byId.value[id] || null;

    return { methods, count, defaultMethod, byId, getMethod };
}
